import { motion } from 'framer-motion';

const fadeUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5 } },
};

export default function LandingPrivacy() {
  return (
    <section className="pt-32 pb-24 bg-white min-h-screen">
      <div className="max-w-3xl mx-auto px-6">
        <motion.div initial="hidden" animate="visible" variants={fadeUp}>
          <h1 className="text-3xl font-light text-slate-900 mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Politique de confidentialité
          </h1>
          <p className="text-sm text-slate-400 mb-10">Dernière mise à jour : 17/04/2026</p>

          <div className="prose prose-slate prose-sm max-w-none space-y-8">
            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">1. Préambule</h2>
              <p className="text-sm text-slate-600 leading-relaxed">
                La société Anticiper (SASU, SIRET 88523614100010), dont le siège social est situé au BP 12 - Rue George Besse - 78330 Fontenay-le-Fleury, s'engage à protéger la vie privée des utilisateurs du site www.anticiper.net conformément au Règlement (UE) 2016/679 du 27 avril 2016 (RGPD) et à la loi n°78-17 du 6 janvier 1978 modifiée relative à l'informatique, aux fichiers et aux libertés.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">2. Responsable du traitement</h2>
              <ul className="text-sm text-slate-600 space-y-1 ml-4">
                <li><strong>Anticiper</strong> – BP 12 - Rue George Besse - 78330 Fontenay-le-Fleury</li>
                <li><strong>SIRET :</strong> 88523614100010</li>
                <li><strong>Email :</strong> contact@anticiper.net</li>
                <li><strong>Représentant légal :</strong> Thierry Assonion</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">3. Données collectées</h2>
              <h3 className="text-base font-medium text-slate-800 mb-2">3.1 Via les cookies et outils analytiques</h3>
              <p className="text-sm text-slate-600 leading-relaxed mb-2">Lors de votre navigation, nous collectons automatiquement :</p>
              <ul className="text-sm text-slate-600 space-y-1 ml-4 mb-4">
                <li>Adresse IP (anonymisée)</li>
                <li>Type de navigateur et version</li>
                <li>Système d'exploitation</li>
                <li>Pages visitées et durée de consultation</li>
                <li>Source de provenance (référent)</li>
                <li>Données de localisation approximative (pays, région)</li>
              </ul>
              <h3 className="text-base font-medium text-slate-800 mb-2">3.2 Via le formulaire de contact / demande de devis</h3>
              <ul className="text-sm text-slate-600 space-y-1 ml-4">
                <li>Nom et prénom</li>
                <li>Adresse email</li>
                <li>Numéro de téléphone (si renseigné)</li>
                <li>Nom de votre organisation (si renseigné)</li>
                <li>Le contenu de votre message</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">4. Finalités et bases légales</h2>
              <ul className="text-sm text-slate-600 space-y-2 ml-4">
                <li><strong>Mesure d'audience :</strong> sur la base de votre consentement (article 6.1.a du RGPD), via les cookies analytiques.</li>
                <li><strong>Traitement de vos demandes :</strong> sur la base de notre intérêt légitime (article 6.1.f du RGPD) à répondre à vos sollicitations.</li>
                <li><strong>Envoi d'informations commerciales :</strong> sur la base de votre consentement, uniquement si vous avez accepté de recevoir ce type de communications.</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">5. Cookies</h2>
              <p className="text-sm text-slate-600 leading-relaxed mb-3">
                Un cookie est un petit fichier texte déposé sur votre terminal lors de votre visite sur un site web. Notre site utilise :
              </p>
              <ul className="text-sm text-slate-600 space-y-2 ml-4">
                <li><strong>Cookies strictement nécessaires :</strong> indispensables au fonctionnement du site. Ils ne nécessitent pas votre consentement.</li>
                <li><strong>Cookies analytiques :</strong> nous permettent de mesurer l'audience et d'analyser le comportement des visiteurs. Déposés uniquement avec votre consentement.</li>
              </ul>
              <p className="text-sm text-slate-600 leading-relaxed mt-3">
                Vous pouvez à tout moment modifier vos choix via les paramètres de votre navigateur.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">6. Destinataires des données</h2>
              <p className="text-sm text-slate-600 leading-relaxed">
                Vos données personnelles sont destinées exclusivement à la société Anticiper et à son personnel habilité. Elles ne sont ni vendues ni cédées à des tiers à des fins commerciales. Elles peuvent toutefois être transmises à des prestataires techniques agissant en qualité de sous-traitants, dans le strict cadre de l'exécution de leurs missions et sous garanties contractuelles conformes au RGPD.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">7. Durée de conservation</h2>
              <ul className="text-sm text-slate-600 space-y-1 ml-4">
                <li><strong>Données de contact :</strong> conservées 3 ans à compter du dernier contact</li>
                <li><strong>Données analytiques (cookies) :</strong> conservées 13 mois maximum</li>
                <li><strong>Données de prospection :</strong> conservées 3 ans à compter de votre consentement</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">8. Transferts hors Union européenne</h2>
              <p className="text-sm text-slate-600 leading-relaxed">
                Dans le cas où certains de nos prestataires seraient établis hors de l'Union européenne, nous nous assurons que des garanties appropriées sont mises en place (clauses contractuelles types, décision d'adéquation, etc.) afin d'assurer un niveau de protection équivalent.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">9. Vos droits</h2>
              <p className="text-sm text-slate-600 leading-relaxed mb-2">Conformément au RGPD, vous disposez des droits suivants :</p>
              <ul className="text-sm text-slate-600 space-y-1 ml-4">
                <li><strong>Droit d'accès :</strong> obtenir une copie des données vous concernant</li>
                <li><strong>Droit de rectification :</strong> corriger des données inexactes ou incomplètes</li>
                <li><strong>Droit à l'effacement :</strong> demander la suppression de vos données</li>
                <li><strong>Droit à la limitation :</strong> demander la suspension temporaire du traitement</li>
                <li><strong>Droit d'opposition :</strong> vous opposer au traitement fondé sur l'intérêt légitime</li>
                <li><strong>Droit à la portabilité :</strong> récupérer vos données dans un format structuré</li>
                <li><strong>Droit de retrait du consentement :</strong> retirer votre consentement à tout moment</li>
              </ul>
              <p className="text-sm text-slate-600 leading-relaxed mt-3">
                Pour exercer ces droits : <strong>contact@anticiper.net</strong> ou par courrier à BP 12 - Rue George Besse - 78330 Fontenay-le-Fleury. Délai de réponse : un mois.
              </p>
              <p className="text-sm text-slate-600 leading-relaxed mt-2">
                Vous pouvez également introduire une réclamation auprès de la <strong>CNIL</strong> (www.cnil.fr).
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">10. Sécurité des données</h2>
              <p className="text-sm text-slate-600 leading-relaxed">
                La société Anticiper met en œuvre toutes les mesures techniques et organisationnelles appropriées pour protéger vos données. Notre site est hébergé par OVH SAS, prestataire certifié offrant des garanties de sécurité conformes aux standards du secteur.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">11. Modification de la politique</h2>
              <p className="text-sm text-slate-600 leading-relaxed">
                La présente politique peut être mise à jour à tout moment. La date de dernière mise à jour est indiquée en haut du document.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-semibold text-slate-900 mb-3">12. Contact</h2>
              <ul className="text-sm text-slate-600 space-y-1 ml-4">
                <li><strong>Par email :</strong> contact@anticiper.net</li>
                <li><strong>Par courrier :</strong> Impact - BP 12 - Rue George Besse - 78330 Fontenay-le-Fleury</li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
